import { useEffect, useState } from 'react';
import {
  systemPlatformService,
  type SystemPlatform,
} from '@modules/content-plan/services/SystemPlatformService';

export interface UseSystemPlatformsReturn {
  platforms: SystemPlatform[];
  loading: boolean;
  error: Error | null;
}

export function useSystemPlatforms(opts?: { activeOnly?: boolean }): UseSystemPlatformsReturn {
  const [platforms, setPlatforms] = useState<SystemPlatform[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);
  const activeOnly = opts?.activeOnly === true;

  useEffect(() => {
    setLoading(true);
    setError(null);
    const unsub = systemPlatformService.subscribePlatforms(
      (next) => {
        setPlatforms(next);
        setLoading(false);
      },
      (err) => {
        setError(err);
        setLoading(false);
      },
      { activeOnly },
    );
    return () => unsub();
  }, [activeOnly]);

  return { platforms, loading, error };
}
